import { useState, useEffect } from 'react'

export const useGetCodeCountryUser = () => {
    const [countryCode, setCountryCode] = useState('us')

    // Виконуємо запит до API для визначення країни за IP
    useEffect(() => {
        const fetchUserCountry = async () => {
            try {
                const response = await fetch('https://ipapi.co/json/')
                if (!response.ok) {
                    throw new Error('Failed to fetch country data')
                }
                const data = await response.json()
                const countryCode = data.country_code.toLowerCase()
                setCountryCode(countryCode)
            } catch (error) {
                console.error('Error fetching user country:', error)
            }
        }

        fetchUserCountry()
    }, [])

    return countryCode
}
